import Model, { attr } from '@ember-data/model';

export default class ReviewItemModel extends Model {
  @attr('string') contactId?: string;
  @attr('number') declare reviewTypeId: number;
  @attr('boolean') declare answered: boolean;
  @attr('date') createdAt?: Date;
  @attr() custom: any;
  @attr() saveCommand: any;
}
